export interface Post {
  id: string;
  title: string;
  categoryId: string;
  tags: string[];
  summary: string;
  cover: string;
  date: string;
  views: number;
  hot: boolean;
  content: string[];
}

export const posts: Post[] = [
  {
    id: "variety-live-leak-script",
    title: "某综艺录制现场路透流出，嘉宾互动被指「剧本感拉满」",
    categoryId: "variety",
    tags: ["综艺路透", "剪辑争议", "嘉宾互动"],
    summary:
      "一段录制现场的路透在社区流传，几位嘉宾的互动节奏被网友逐帧拆解。有人觉得是自然反应，也有人认为衔接过于顺滑。节目组暂未回应，讨论仍在继续。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cream%20toned%20editorial%20collage%20of%20a%20bright%20empty%20tv%20studio%20set%20with%20folded%20chairs%20and%20soft%20amber%20light%2C%20clean%20minimal%20magazine%20photography%2C%20muted%20red%20accents%2C%20no%20people%2C%20flat%20modern%20aesthetic&width=1200&height=750&seq=gossip-post-variety-01&orientation=landscape",
    date: "2026-09-12",
    views: 48210,
    hot: true,
    content: [
      "昨天傍晚，一段据称拍摄于录制现场的路透片段在社区里传开。画面里几位嘉宾围坐在长桌旁，谈笑、沉默、再谈笑的节奏被网友反复回看，很快就有人把这段互动做成了逐帧拆解的长图。",
      "支持「自然派」的网友认为，几位嘉宾之间的冷场和抢话恰恰说明现场没有排练，真实感反而更强；而「剧本派」则指出，几次话题转折都精准落在节目需要的情绪点上，衔接过于顺滑，像是提前对过流程。",
      "我们翻了翻社区里热度较高的十几条讨论，发现大家真正在意的其实不是有没有剧本，而是节目最终呈现的剪辑是否尊重了现场。有网友贴出另一段较完整的素材，指出成片里删掉了将近二十分钟的铺垫，导致人物关系看起来比实际更紧张。",
      "截至发稿，节目组尚未对剪辑争议作出回应。按照以往的规律，这类讨论通常会在下一期播出后自然降温，也可能会因为一次正片回击而再度升温。我们会持续跟进后续的官方说明，并同步更新到汇总清单里。",
    ],
  },
  {
    id: "drama-small-budget-rise",
    title: "一部小成本剧逆袭登顶热度榜，观众直呼「被严重低估」",
    categoryId: "drama",
    tags: ["小成本剧", "口碑逆袭", "热度榜"],
    summary:
      "没有大流量阵容，也没有密集宣发，这部剧靠口碑一路爬升到榜单前列。追剧党把它称为「今年最被低估的遗珠」，数据与讨论度都在持续走高。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20cream%20and%20caramel%20editorial%20still%20life%20of%20an%20old%20film%20projector%20and%20stacked%20film%20reels%20on%20a%20linen%20surface%2C%20warm%20window%20light%2C%20muted%20amber%20palette%2C%20soft%20shadows%2C%20minimal%20indie%20aesthetic&width=1200&height=750&seq=gossip-post-drama-02&orientation=landscape",
    date: "2026-09-12",
    views: 41880,
    hot: true,
    content: [
      "一部上线时几乎没什么声响的小成本剧，这一周悄悄爬到了热度榜的靠前位置。它的阵容里没有大众熟知的名字，宣传也只集中在开播前一周，靠的完全是追剧观众之间的口口相传。",
      "从数据上看，这部剧的讨论量增长曲线很有特点：开播前三天平平，第四天开始明显抬头，到周末形成集中爆发。社区里流传的解释是，前期入坑的观众在看完前六集后集中写了长评，把「节奏慢但耐看」这个点讲清楚了，反而吸引了一批原本不打算看的人。",
      "我们整理了几条被反复提到的优点：一是台词写得克制，几乎没有为了煽情而堆砌的台词；二是配角塑造完整，几乎没有纯粹的工具人；三是摄影用光讲究，很多空镜被观众单独截出来当壁纸。",
      "当然也有批评的声音，主要集中在后半段节奏变慢、几条支线收得仓促。不过总体来看，这部剧目前的口碑仍然稳在高位。它会不会成为今年的年度遗珠，还得看收官阶段的表现，相关走势我们会一并更新到归档里。",
    ],
  },
  {
    id: "industry-awards-list-leak",
    title: "某平台年度盛典名单流出，阵容组合引发新一轮讨论",
    categoryId: "industry",
    tags: ["年度盛典", "名单流出", "阵容讨论"],
    summary:
      "一份据称是年度盛典的初步名单在社群间流转，几个此前少有同台的组合被排在一起，很快成了讨论焦点。平台方面未确认名单真实性。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20warm%20neutral%20editorial%20flat%20lay%20of%20blank%20invitation%20cards%20with%20gold%20foil%20edges%20on%20a%20cream%20linen%20background%2C%20soft%20studio%20lighting%2C%20muted%20amber%20and%20charcoal%20tones%2C%20minimal%20luxury%20aesthetic&width=1200&height=750&seq=gossip-post-industry-03&orientation=landscape",
    date: "2026-09-11",
    views: 33760,
    hot: true,
    content: [
      "每逢年底，各类盛典的初步名单都会提前在社群之间流转。这一次流出的版本里，有几个此前几乎没有同台过的组合被排在相邻环节，于是「是不是要搞联动」的猜测迅速铺开。",
      "需要说明的是，这份名单目前没有任何官方渠道确认，格式也更接近内部沟通用的初稿，存在大量调整空间。按照过往经验，盛典流程在正式彩排前往往会改动三到五轮，现在看到的组合只能当作参考。",
      "真正值得留意的，是名单里出现的几个新面孔。他们大多来自今年讨论度较高的作品，说明平台的资源倾斜正在向新一代内容创作者倾斜。这个趋势如果延续，明年的作品格局可能会和今年很不一样。",
      "我们会把这份初稿和后续可能出现的更新版本一起整理进汇总清单，方便大家对照查看哪些组合最终真的同台了。也提醒一句：在官方公布之前，任何名单都请以理性态度看待。",
    ],
  },
  {
    id: "idol-career-transition",
    title: "选秀出身的一批艺人集体转向幕后，新赛道正在成形",
    categoryId: "industry",
    tags: ["职业转型", "幕后创作", "行业观察"],
    summary:
      "几位早年通过选秀被大众认识的艺人，这两年陆续把重心挪到幕后。有人做音乐制作，有人开始参与剧本策划，转型路径出乎很多人意料。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20desk%20scene%20with%20an%20open%20notebook%2C%20headphones%20and%20a%20small%20plant%20in%20soft%20amber%20morning%20light%2C%20cream%20toned%20editorial%20photography%2C%20quiet%20creative%20workspace%20mood%2C%20no%20people&width=1200&height=750&seq=gossip-post-industry-04&orientation=landscape",
    date: "2026-09-11",
    views: 26430,
    hot: false,
    content: [
      "如果把这两年选秀出身艺人的动向拉成一条线，会发现一个挺有意思的现象：越来越多的人把重心从台前挪到了幕后。有人开始署名音乐制作，有人以策划身份参与节目，还有人干脆自己组了工作室。",
      "这个变化的原因并不复杂。舞台类内容的竞争越来越激烈，单靠曝光维持热度的难度明显上升，而幕后身份带来的收入结构更稳定，也更容易长期积累作品。对很多人来说，这是一次主动的职业规划，而不只是「转行」。",
      "值得注意的是，这批人转型的方向各不相同。偏向创作的选择深耕音乐，偏向内容的选择做策划，还有一部分做起了经纪和孵化。不同的路径意味着几年后他们之间的差距可能会被进一步拉开。",
      "从行业角度看，这未必是坏事。台前经验丰富的人进入幕后，往往更懂观众想看什么，也更理解舞台上的实际困难。这条新赛道会走成什么样，值得我们持续观察。",
    ],
  },
  {
    id: "drama-rain-scene-three-days",
    title: "剧组花絮曝光：一场雨戏整整拍了三天，主创集体感冒",
    categoryId: "drama",
    tags: ["剧组花絮", "幕后故事", "拍摄日常"],
    summary:
      "一段剧组纪录片式的花絮让观众第一次看到雨戏的真实拍摄成本。人工降雨、反复重拍、演员保暖，三天时间全耗在这一场戏上。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20warm%20neutral%20editorial%20photo%20of%20an%20empty%20film%20set%20with%20lighting%20stands%2C%20wet%20pavement%20and%20soft%20amber%20backlight%2C%20cream%20and%20charcoal%20tones%2C%20cinematic%20behind%20the%20scenes%20atmosphere%2C%20no%20people&width=1200&height=750&seq=gossip-post-drama-05&orientation=landscape",
    date: "2026-09-10",
    views: 30120,
    hot: true,
    content: [
      "很多人以为雨戏是特效，其实大多数剧组拍雨戏用的都是真水。最近流出的一段花絮里，工作人员详细记录了这场戏的拍摄过程：从架设降雨设备、铺设排水通道，到反复调整机位，光是准备就花了半天。",
      "真正难的是重拍。同一个镜头不同的景别都要单独拍一遍，演员每次都要在湿透的状态下重新进入情绪。花絮里可以看到，主创们拍了三天，到最后几乎是靠热水和姜茶撑下来的，播出的成片却只有不到四分钟。",
      "这段花絮之所以被大量转发，是因为它让观众第一次直观感受到「一场戏」背后的人力成本。有网友评论说，看完之后再回看正片，连雨滴的节奏都觉得是精心设计过的。",
      "片方表示，后续还会放出更多幕后内容，包括武戏和夜戏的拍摄记录。对喜欢看制作过程的观众来说，这算是一份额外的福利，我们也会把相关更新同步到帖子详情里。",
    ],
  },
  {
    id: "variety-editing-dispute-response",
    title: "某综艺剪辑争议持续发酵，节目组发布长文回应",
    categoryId: "variety",
    tags: ["剪辑争议", "官方回应", "舆论走向"],
    summary:
      "针对持续数日的剪辑争议，节目组发布了一篇长文说明剪辑逻辑，并承认部分衔接处理不够清楚。回应能否平息讨论，还要看下一期播出效果。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cream%20editorial%20photo%20of%20a%20video%20editing%20timeline%20interface%20on%20a%20monitor%20with%20soft%20amber%20room%20light%2C%20minimal%20workspace%2C%20charcoal%20and%20beige%20palette%2C%20clean%20modern%20mood%2C%20no%20people&width=1200&height=750&seq=gossip-post-variety-06&orientation=landscape",
    date: "2026-09-10",
    views: 28940,
    hot: false,
    content: [
      "这场争议从上周开始，核心问题只有一个：节目成片里的几处衔接，是否让人物关系看起来比实际更紧张。讨论从粉丝圈扩散到普通观众，很快就上了热门话题。",
      "节目组这次没有选择沉默，而是发布了一篇接近两千字的长文。文中逐一解释了三个被质疑最多的片段的剪辑思路，并坦承其中一处过渡确实处理得不够清楚，容易造成误解。",
      "长文里有一句话被大量引用：「我们希望在有限时长里保留更多真实瞬间，但在取舍之间，确实可能让信息变得不完整。」这句话既像是解释，也像是让步，网友对它的解读分成两派。",
      "从舆论走势看，官方回应至少止住了情绪化的部分，讨论开始回到剪辑本身。接下来关键的一步是下一期正片，如果那期的叙述更完整，这次风波大概率会很快过去。",
    ],
  },
  {
    id: "industry-short-drama-wave",
    title: "短剧赛道再升温：一周上线近百部，观众到底在为什么买单",
    categoryId: "industry",
    tags: ["短剧", "内容趋势", "行业观察"],
    summary:
      "短剧的产量还在加速。仅上一周就有接近百部新作上线，题材集中在几个固定方向。它为什么能留住观众，值得认真拆一拆。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20stack%20of%20blank%20smartphone%20screens%20arranged%20in%20a%20grid%20on%20a%20cream%20surface%20with%20soft%20amber%20lighting%2C%20abstract%20content%20grid%20concept%2C%20muted%20beige%20and%20charcoal%20palette%2C%20no%20people&width=1200&height=750&seq=gossip-post-industry-07&orientation=landscape",
    date: "2026-09-09",
    views: 22150,
    hot: false,
    content: [
      "短剧的产量还在往上走。仅上一周，主流平台上线的新作就接近一百部，题材集中在都市情感、家庭关系和轻悬疑几个方向，重复度不低，但观众似乎并不完全排斥重复。",
      "为什么会这样？和长剧相比，短剧的优势在于「决策成本低」。用户点开一部短剧，几秒钟就能判断要不要继续看，不合适立刻划走，几乎没有心理负担。这种低门槛让它在碎片时间里特别有竞争力。",
      "另一个关键点是节奏。短剧通常在开头三十秒内就抛出冲突，两分钟内完成一次反转，观众获得的情绪反馈非常密集。对习惯了短视频节奏的人来说，这种内容形态几乎是天然适配的。",
      "但高产量也带来了问题：同质化严重，真正能被记住的作品比例很低。接下来这个赛道能不能从「量」转向「质」，可能取决于平台是否愿意为更好的剧本和制作买单。",
    ],
  },
  {
    id: "variety-classic-show-reboot",
    title: "老牌综艺宣布改版，情怀与创新之间如何取舍",
    categoryId: "variety",
    tags: ["老牌综艺", "改版", "情怀"],
    summary:
      "一档播出多年的综艺宣布全新改版，赛制和常驻阵容都有调整。老观众担心「改得没内味儿」，新观众则期待更紧凑的节奏。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20editorial%20still%20of%20vintage%20stage%20spotlights%20and%20velvet%20curtains%20in%20soft%20amber%20and%20cream%20tones%2C%20minimal%20retro%20theater%20mood%2C%20no%20people%2C%20clean%20composition&width=1200&height=750&seq=gossip-post-variety-08&orientation=landscape",
    date: "2026-09-09",
    views: 19780,
    hot: false,
    content: [
      "一档陪伴观众多年的综艺宣布改版，消息一出，评论区立刻分成两拨。老观众最关心的是「内味儿还在不在」，新观众则更在意节奏能不能跟上现在的观看习惯。",
      "从公布的信息看，这次改版动作不小：赛制做了重构，常驻阵容也有调整，还加入了几位年轻嘉宾。节目组把它定义为「一次面向新阶段的升级」，但升级的代价是必须放弃一部分延续多年的设定。",
      "情怀与创新的矛盾，几乎是所有长寿节目的必经关口。完全不变会显得陈旧，变得太狠又会丢掉基本盘。真正难的，是找到那个既能保留核心体验、又能让新观众进来的平衡点。",
      "这档节目最终能不能改成功，现在下结论还太早。我们更愿意先看前几期的实际反馈，再把观众的评价整理进归档，用数据来判断这次改版到底走对了没有。",
    ],
  },
  {
    id: "drama-finale-record-discussion",
    title: "某剧大结局讨论量破纪录，开放式结尾被刷屏",
    categoryId: "drama",
    tags: ["大结局", "开放式结尾", "讨论破纪录"],
    summary:
      "一部热播剧以开放式结局收官，最后一集的讨论量创下平台纪录。有人叫好，有人意难平，关于结尾的两种理解几乎势均力敌。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photo%20of%20an%20empty%20theater%20seat%20row%20with%20soft%20amber%20screen%20glow%2C%20cream%20and%20charcoal%20tones%2C%20minimal%20melancholic%20mood%2C%20no%20people%2C%20film%20grain&width=1200&height=750&seq=gossip-post-drama-09&orientation=landscape",
    date: "2026-09-08",
    views: 45320,
    hot: true,
    content: [
      "这部剧昨晚收官，最后一集上线后不到两小时，讨论量就超过了此前平台保持的纪录。真正引爆讨论的，是那个几乎没有给出明确答案的开放式结尾。",
      "结尾停留在主角的一个背影和一句没有说完的话上。一部分观众认为这是高级处理，留白让每个人都能得到属于自己的结局；另一部分观众则觉得被「吊」了太久，需要一个明确的交代。",
      "有意思的是，两种理解的声量非常接近。我们随机统计了热门讨论里的一千条评论，支持和反对的比例大约是五十三比四十七，几乎可以算作平手。这种势均力敌的讨论氛围，反过来又推高了剧集的热度。",
      "主创团队在随后的直播里回应，开放式结尾是创作之初就定下的方向，并非为了续集铺垫。至于观众信不信这个说法，大概就是这部剧留下的最后一道「开放式问题」了。",
    ],
  },
  {
    id: "idol-music-festival-live",
    title: "音乐节现场直击：观众合唱盖过音响，返场加了两首",
    categoryId: "idol",
    tags: ["音乐节", "现场直击", "返场"],
    summary:
      "一场周末音乐节因为观众的全场合唱登上热搜。主舞台的返场环节临时加了两首歌，成为当晚被讨论最多的瞬间。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20amber%20toned%20editorial%20photo%20of%20a%20crowded%20outdoor%20music%20festival%20at%20dusk%20with%20warm%20stage%20lights%20and%20cream%20sky%2C%20silhouettes%20of%20a%20crowd%20from%20behind%2C%20cinematic%20minimal%20mood%2C%20festival%20atmosphere&width=1200&height=750&seq=gossip-post-idol-10&orientation=landscape",
    date: "2026-09-08",
    views: 24670,
    hot: false,
    content: [
      "这个周末的音乐节，被讨论最多的不是阵容，而是一个现场瞬间：当主舞台唱到那首传唱度很高的歌时，全场观众的合唱盖过了音响，连后台的工作人员都停下来听。",
      "据在现场的观众描述，合唱从副歌开始，逐渐蔓延到整个场地，很多人是举着手机边唱边录。这种「集体瞬间」在音乐节里并不常见，它需要一首足够被熟知的歌，也需要一个足够投入的现场。",
      "也许是受了现场气氛感染，主舞台的返场环节临时加了两首歌，比原定流程多出了将近十五分钟。这个即兴决定后来被剪成短视频广泛传播，成了当晚最有记忆点的部分。",
      "音乐节结束后，关于「现场体验为什么不可替代」的讨论又热了起来。对很多人来说，去现场不是为了听没有瑕疵的歌声，而是为了成为那个合唱里的一员。",
    ],
  },
  {
    id: "industry-studio-operation",
    title: "行业观察：艺人工作室的运营模式正在悄悄改变",
    categoryId: "industry",
    tags: ["工作室", "运营模式", "行业观察"],
    summary:
      "过去以经纪为核心的工作室，正在把重心转向内容孵化。这个转变背后，是平台、艺人和市场三方关系的重新调整。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20shot%20of%20a%20clean%20modern%20office%20desk%20with%20charts%20on%20paper%2C%20a%20cup%20of%20coffee%20and%20soft%20amber%20window%20light%2C%20cream%20and%20charcoal%20palette%2C%20quiet%20professional%20mood%2C%20no%20people&width=1200&height=750&seq=gossip-post-industry-11&orientation=landscape",
    date: "2026-09-07",
    views: 15980,
    hot: false,
    content: [
      "如果你留意近两年的行业动态，会发现一个不太显眼但很关键的变化：不少艺人工作室的主营业务，正在从单纯的经纪转向内容孵化。",
      "过去工作室的核心工作是接洽资源和维护形象，现在越来越多的工作室开始自己投资剧本、组盘制作、参与发行。这么做的好处是显而易见的：一旦内容成功，收获的就不只是艺人的曝光，还有作品本身的长期价值。",
      "这个转变的背后，是平台、艺人和市场三方关系的一次重新调整。平台需要稳定的优质内容供给，艺人需要更主动的创作话语权，而市场则更愿意为有诚意的作品买单。三者叠加，工作室的角色自然被推到了内容生产的前端。",
      "当然，这条路并不好走。内容投资的周期长、风险高，回报也不像经纪业务那样可预期。工作室模式能不能真正跑通，还有待时间和作品来验证。",
    ],
  },
  {
    id: "drama-wraps-cast-debut",
    title: "某剧组正式官宣杀青，主创阵容首次集体亮相",
    categoryId: "drama",
    tags: ["杀青", "主创阵容", "开机现场"],
    summary:
      "历经数月拍摄，一部备受关注的新剧正式杀青。官方放出的杀青合影里，主创阵容首次完整公开，几位新面孔引起讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cream%20editorial%20still%20of%20a%20film%20clapperboard%20and%20a%20bouquet%20of%20dried%20flowers%20on%20a%20wooden%20table%20with%20soft%20amber%20light%2C%20minimal%20celebration%20mood%2C%20beige%20and%20charcoal%20palette%2C%20no%20people&width=1200&height=750&seq=gossip-post-drama-12&orientation=landscape",
    date: "2026-09-07",
    views: 18430,
    hot: false,
    content: [
      "经过几个月的拍摄，这部新剧日前正式宣布杀青。官方发布的杀青合影里，主创阵容第一次完整地出现在同一张照片里，评论区很快就被「终于等到」刷屏。",
      "从合影看，这次的主创搭配挺有新意：几位观众熟悉的演员之外，还有几张相对陌生的面孔。据片方介绍，这几位是经过多轮试镜后确定的新人，在剧中承担的戏份并不轻。",
      "关于剧集本身，目前公开的信息还很有限，只知道题材偏向现实向，拍摄跨越了多个城市。片方表示，后期制作预计需要几个月时间，具体的播出档期还在协调中。",
      "对观众来说，从杀青到真正播出往往还有一段不短的等待。这段时间里，任何关于阵容和剧情的消息都容易引发讨论。我们会保持关注，并及时把官方更新整理到帖子详情里。",
    ],
  },
  {
    id: "community-classic-lines-archaeology",
    title: "网络热梗考古：那些年被玩坏的经典台词是怎么火的",
    categoryId: "community",
    tags: ["热梗考古", "经典台词", "社区盘点"],
    summary:
      "一批老剧里的台词最近又被翻出来玩梗，热度不减当年。为什么有些句子能穿越时间，有些却只能火一周？我们来盘一盘。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20editorial%20flat%20lay%20of%20old%20film%20strips%2C%20vintage%20paper%20and%20a%20magnifying%20glass%20on%20a%20cream%20surface%2C%20soft%20amber%20lighting%2C%20muted%20beige%20and%20charcoal%20palette%2C%20no%20people&width=1200&height=750&seq=gossip-post-community-13&orientation=landscape",
    date: "2026-09-06",
    views: 21040,
    hot: false,
    content: [
      "每隔一段时间，总会有几句老剧台词被重新翻出来，配上新的语境，再火一遍。这一轮被玩坏的是几条出自十多年前电视剧的对话，短短几天就被做成了上百个版本。",
      "为什么有些台词能穿越时间，有些只能火一周？观察下来，能被反复使用的句子往往有一个共同点：句式简洁、情绪明确，而且可以套进各种场景。换句话说，它得是一个「好用的模板」，而不仅仅是一句好听的话。",
      "另一个因素是共鸣。那些真正长红的台词，大多说出了某种很多人都有过的感受，比如尴尬、倔强或者不甘心。当观众把它搬进现实场景，句子就被赋予了新的生命力。",
      "从这个角度看，玩梗其实是一种集体的再创作。它把一个原本属于作品的瞬间，变成了所有人都能参与的表达方式。这也是为什么，好的台词总是比好剧本身活得更久。",
    ],
  },
  {
    id: "community-weekly-five-moments",
    title: "社区盘点：这一周最出圈的五个名场面",
    categoryId: "community",
    tags: ["每周盘点", "名场面", "社区精选"],
    summary:
      "一周结束，社区里被反复回放的名场面已经排出了高下。从现场合唱到结局背影，五个瞬间撑起了这周的讨论热度。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20collage%20of%20blank%20photo%20frames%20arranged%20loosely%20on%20a%20cream%20linen%20background%20with%20soft%20amber%20lighting%2C%20minimal%20gallery%20grid%20concept%2C%20beige%20and%20charcoal%20palette%2C%20no%20people&width=1200&height=750&seq=gossip-post-community-14&orientation=landscape",
    date: "2026-09-06",
    views: 17620,
    hot: false,
    content: [
      "一周过去，社区里被反复回放的片段已经自然排出了高下。我们把热度最高的五个瞬间整理出来，它们分别来自不同的内容领域，却有一个共同点：都是真实发生的现场。",
      "排在前面的是音乐节上的全场合唱，其次是某剧大结局的那个背影，第三是综艺录制路透里的一个意外停顿。后面两位分别是剧组雨戏的花絮和一档节目的即兴返场。",
      "观察这五个瞬间，会发现它们都不依赖特效或剪辑技巧，靠的是情绪的浓度。观众愿意反复回看的，往往是某个人在某个瞬间真实流露的反应，而不是精心设计的桥段。",
      "这也算是给内容创作者的一个提示：观众不傻，他们能分辨什么是真诚、什么是套路。下周的盘点我们会继续更新，也欢迎把你觉得被遗漏的名场面补充进来。",
    ],
  },
];

export function getPostById(id: string): Post | undefined {
  return posts.find((p) => p.id === id);
}

export function getPostsByCategory(categoryId: string): Post[] {
  return posts.filter((p) => p.categoryId === categoryId);
}